<template>
  <div @click="toLearn" class="recommend-course-item-box">
    <img :src="courseData.thumb" alt class="course-img"/>
    <div class="info-box">
      <div class="course-name van-multi-ellipsis--l2">{{courseData.courseName}}</div>
      <div class="course-duration">{{courseData.classCount}}课时</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "RecommendCourseItem",
  props: ['courseData'],
  data () {
    return {
    };
  },
  methods: {
    toLearn () {
      let data = {
        courseData: this.courseData,
        isRecommend: true,
        tourist : localStorage.getItem('tourist')  || sessionStorage.getItem('tourist')
      }
       setTimeout(() => {
        this.$router.push(
          {
            name: 'CourseDetailMobile',
            params: data
          }
        )
        sessionStorage.setItem('h5curriculumSchedule', JSON.stringify(data))
      }, 200)
    }
  }
}
</script>
<style lang="less" scoped>
.recommend-course-item-box {
  display: flex;
  margin-bottom: 15px;
  .course-img {
    width: 140px;
    height: 89px;
  }
  .info-box {
    margin-left: 15px;
  }

  .course-name {
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 24px;
  }
  .course-duration {
    margin-top: 15px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(210, 210, 210, 1);
    line-height: 12px;
  }
}
</style>
